module.exports = "<app-navbar></app-navbar>\n\n<main role=\"main\" class=\"container\">\n  \n  <router-outlet></router-outlet>\n\n</main><!-- /.container -->\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main